// alfredHR wordmark — rendered as inline text so the brand is always accurate.
// Variants:
//   wordmark        → pink "alfred" + navy "HR"           (light surfaces)
//   wordmark-white  → pink "alfred" + white "HR"          (dark surfaces / sidebar / landing)
//   mark-dark       → circular navy tile with pink "aH"   (favicons/tight spaces on light bg)
//   mark-light      → circular pink tile with white "aH"  (favicons/tight spaces on dark bg)

export default function Logo({ variant = "wordmark", size = 28, className = "" }) {
  const isMark = variant === "mark-dark" || variant === "mark-light";
  const isWhite = variant === "wordmark-white";

  if (isMark) {
    const bg = variant === "mark-dark" ? "#00214D" : "#FF007F";
    const fg = variant === "mark-dark" ? "#FF007F" : "#FFFFFF";
    return (
      <span
        role="img"
        aria-label="alfredHR"
        data-testid="alfred-logo"
        className={`inline-flex items-center justify-center rounded-full font-display font-black select-none ${className}`}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          background: bg,
          color: fg,
          fontSize: `${Math.round(size * 0.42)}px`,
          letterSpacing: "-0.02em",
          lineHeight: 1,
        }}
      >
        aH
      </span>
    );
  }

  const hrColor = isWhite ? "#FFFFFF" : "#00214D";
  return (
    <span
      role="img"
      aria-label="alfredHR"
      data-testid="alfred-logo"
      className={`inline-flex items-baseline font-display font-black tracking-tight select-none ${className}`}
      style={{ fontSize: `${size}px`, lineHeight: 1, letterSpacing: "-0.03em" }}
    >
      <span style={{ color: "#FF007F" }}>alfred</span>
      <span style={{ color: hrColor, marginLeft: `${Math.round(size * 0.05)}px` }}>HR</span>
    </span>
  );
}
